import { mySchedules } from './mySchedules';

export const pt = {
  mySchedules,
};
